import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getClientDashboardStats,
  regenerateClientCode,
} from '../../../../services/dashboard/users';

export const clientDashboardQueryKeys = {
  stats: ['clientDashboardStats'],
};

export function useClientDashboardStats() {
  return useQuery({
    queryKey: clientDashboardQueryKeys.stats,
    queryFn: getClientDashboardStats,
    staleTime: 30_000,
  });
}

export function useRegenerateClientCode({ onSuccess, onError } = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: regenerateClientCode,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: clientDashboardQueryKeys.stats });
      onSuccess?.(data);
    },
    onError,
  });
}
